import { Search } from '@mui/icons-material'
import { InputAdornment, TextField } from '@mui/material'
import { ChangeEvent, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PAGES_ROUTES } from '../../../Constants'
import { API_CONFIG, API_LIST } from '../../../Constants/ApiDefinations'
import mainApiService from '../../../Services'
import { useAppDispatch } from '../../../Store/Hooks'
import { setLoader } from '../../../Store/Slice/loader.slice'
import SettingIcon from '../../Icons/SettingIcon'
import MUITooltip from '../MUI-Tooltip'
import './header.scss'

const AdvanceSearch = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [searchInput, setSearchInput] = useState('')
  const [savedSearches, setSavedSearches] = useState<any[]>([])
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [anchorElForSaveSearch, setAnchorElForSaveSearch] = useState<boolean>(false)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setAnchorElForSaveSearch(false)
        setSavedSearches([])
      }
    }

    if (anchorElForSaveSearch) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [anchorElForSaveSearch])

  const getSaveSearchListFunction = async () => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(API_LIST.ADVANCED_SEARCH.SAVE_SEARCH_LIST, null, null, {
      page: 1,
      limit: 3,
    })
    const result: any = await mainApiService(requestedData)
    if (result?.responseCode === 200) {
      const tempData: any[] = []
      result?.data?.records?.forEach((ele: any) => {
        tempData.push({ id: ele._id, name: ele.name })
      })
      setSavedSearches(tempData)
      dispatch(setLoader(false))
    } else {
      setSavedSearches([])
      dispatch(setLoader(false))
    }
  }

  const handleEnterKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (searchInput.trim().length > 2) {
        navigate(`/home/asset-state-details/${PAGES_ROUTES.AdvancedSearch}?search=${searchInput}`)
        setSearchInput('')
      }
    }
  }

  return (
    <div className='advanced-search'>
      <TextField
        className='global-search-input pl-0'
        id='outlined-search'
        autoComplete='off'
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setSearchInput(e.target.value)
        }}
        value={searchInput}
        onFocus={() => {
          setAnchorElForSaveSearch(true)
          getSaveSearchListFunction()
        }}
        onKeyDown={handleEnterKeyPress}
        placeholder={'Search by Title and Id'}
        InputProps={{
          id: 'searchId',
          startAdornment: (
            <InputAdornment position='start'>
              <Search style={{ color: '#B1B4B6' }} />
            </InputAdornment>
          ),
        }}
        type='search'
      />
      {anchorElForSaveSearch && savedSearches.length ? (
        <div
          className='savesearch-popup-wrapper'
          ref={dropdownRef}
          onMouseDown={(e) => {
            e.stopPropagation()
          }}
        >
          <div
            onClick={() => {
              setAnchorElForSaveSearch(true)
            }}
            className='d-flex justify-content-between align-items-center savesearch-popup-header'
          >
            <div className='heading-6'>Saved Searches</div>
            <u
              className='col1 cursor-pointer'
              onClick={(e: any) => {
                e.stopPropagation()
                setAnchorElForSaveSearch(false)
                setSavedSearches([])
                navigate('/home/asset-state-details/save-search', {
                  state: {
                    pathName: window.location.href.split(window.location.host)[1],
                    state: state,
                  },
                })
              }}
            >
              View all
            </u>
          </div>
          <div className='search-list'>
            {savedSearches.map((search: any, index: any) => {
              return (
                <div
                  key={search?.id}
                  data-testid={`savesearch-${index}`}
                  className='heading-search cursor-pointer'
                  onClick={(e: any) => {
                    e.stopPropagation()
                    setAnchorElForSaveSearch(false)
                    setSavedSearches([])
                    navigate(
                      `/home/asset-state-details/${PAGES_ROUTES.AdvancedSearch}?name=${search?.name}`,
                      {
                        state: { id: search?.id },
                      },
                    )
                  }}
                >
                  {index + 1}. {search.name}
                </div>
              )
            })}
          </div>
        </div>
      ) : (
        <></>
      )}
      <MUITooltip
        disableInteractive={true}
        title='Advanced Search'
        placement='bottom-start'
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              padding: '4px 8px 4px 8px',
              fontSize: '12px',
              fontWeight: '500',
              color: '#402080',
              bgcolor: '#ECE9F2',
              '& .MuiTooltip-arrow': {
                color: '#ECE9F2',
              },
            },
          },
        }}
        data-testid={'open_drawer_test_id'}
        sx={{
          marginRight: 2,
        }}
      >
        <Link
          to={{
            pathname: `/home/asset-state-details/${PAGES_ROUTES.AdvancedSearch}`,
            search: `?search=${searchInput}&advanceSearch=1`,
          }}
          style={{ textDecoration: 'none' }}
          className='table-link'
          data-testid='advance_btn'
        >
          <div className='search-advanced-btn'>
            <SettingIcon />
          </div>
        </Link>
      </MUITooltip>
    </div>
  )
}
export default AdvanceSearch
